const StepsCompletedEN = {
  StepsCompleted: {
    TITLE: 'Thanks!',
    TEXT: 'We will soon send the next steps in your email.',
  },
};

const StepsCompletedPT = {
  StepsCompleted: {
    TITLE: 'Obrigado!',
    TEXT: 'Enviaremos em breve os próximos passos no seu email.',
  },
};

export { StepsCompletedPT, StepsCompletedEN };
